






















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import { IClient } from "@/models/clients";
import Context from "@/mixins/context";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdImage extends Mixins(Context) {
  // Props

  @Prop({ default: undefined })
  public readonly contractProduct?: IContractProduct;

  @Prop({ default: undefined })
  public readonly client?: IClient;

  @Prop({ default: false })
  public readonly isLoading?: boolean;

  @Prop({ default: 64 })
  public readonly size!: number;

  @Prop({ default: 100 })
  public readonly quality!: 50 | 100 | 200 | 300 | 400;

  // Computed

  public get avatarBindings() {
    return {
      size: Math.max(this.size / 2, 32), // 32px minimum
      name: this.client?.fullname,
      email: this.client?.email,
      src: this.client?.image_url
    };
  }
}
